import React, { useState, useRef } from 'react';
import { useAuth } from '../contexts/AuthContext';
import './LoginModal.css';

const LoginModal = ({ isOpen, onClose }) => {
  const [isLoginView, setIsLoginView] = useState(true);
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const emailRef = useRef();
  const passwordRef = useRef();
  const passwordConfirmRef = useRef();
  const { login, signup, loginWithGoogle } = useAuth();

  const handleAuthAction = async (e) => {
    e.preventDefault();
    setError('');
    setMessage('');
    setLoading(true);

    if (!isLoginView) {
      if (passwordRef.current.value !== passwordConfirmRef.current.value) {
        setError('パスワードが一致しません。');
        setLoading(false);
        return;
      }
    }

    try {
      if (isLoginView) {
        await login(emailRef.current.value, passwordRef.current.value);
        onClose();
      } else {
        await signup(emailRef.current.value, passwordRef.current.value);
        setMessage('確認メールを送信しました。\nメールをご確認の上、ログインしてください。');
      }
    } catch (err) {
      setError(getFriendlyErrorMessage(err.code));
    } finally {
      setLoading(false);
    }
  };

  const handleGoogleSignIn = async () => {
    setError('');
    setLoading(true);
    try {
      await loginWithGoogle();
      onClose();
    } catch (err) {
      setError(getFriendlyErrorMessage(err.code));
    } finally {
      setLoading(false);
    }
  };

  const getFriendlyErrorMessage = (errorCode) => {
    switch (errorCode) {
      case 'auth/invalid-email':
        return '無効なメールアドレスです。';
      case 'auth/user-disabled':
        return 'このアカウントは無効化されています。';
      case 'auth/user-not-found':
      case 'auth/wrong-password':
        return 'メールアドレスまたはパスワードが正しくありません。';
      case 'auth/invalid-credential':
        return 'メールアドレスまたはパスワードが正しくありません。';
      case 'auth/email-not-verified':
        return 'メールアドレスが確認されていません。確認メールをご確認ください。';
      case 'auth/email-already-in-use':
        return 'このメールアドレスは既に使用されています。';
      case 'auth/weak-password':
        return 'パスワードは6文字以上で設定してください。';
      case 'auth/popup-closed-by-user':
        return 'Googleサインインがキャンセルされました。';
      default:
        return 'エラーが発生しました。もう一度お試しください。';
    }
  };


  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <button className="modal-close-btn" onClick={onClose}>&times;</button>
        <h2>{isLoginView ? 'ログイン' : '新規登録'}</h2>
        {error && <p className="modal-error">{error}</p>}
        {message && <p className="modal-message">{message}</p>}
        <form onSubmit={handleAuthAction}>
          <div className="form-group">
            <label>メールアドレス</label>
            <input type="email" ref={emailRef} required />
          </div>
          <div className="form-group">
            <label>パスワード</label>
            <input type="password" ref={passwordRef} required />
          </div>
          {!isLoginView && (
            <div className="form-group">
              <label>パスワード（確認用）</label>
              <input type="password" ref={passwordConfirmRef} required />
            </div>
          )}
          <button type="submit" className="modal-btn primary" disabled={loading}>
            {loading ? '処理中...' : (isLoginView ? 'ログイン' : '新規登録')}
          </button>
        </form>
        <div className="modal-divider">または</div>
        <button className="modal-btn google" onClick={handleGoogleSignIn} disabled={loading}>
          <img src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg" alt="Google" />
          Googleで{isLoginView ? 'ログイン' : '登録'}
        </button>
        <div className="modal-switch">
          {isLoginView ? 'アカウントをお持ちでないですか？' : 'すでにアカウントをお持ちですか？'}
          <button onClick={() => { setIsLoginView(!isLoginView); setError(''); }}>
            {isLoginView ? '新規登録' : 'ログイン'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default LoginModal;
